import ContentCreate from '@material-ui/icons/Create';
import { Button } from "react-admin";

const DialogEdit = (propsReceive) => {
    const { onClick, record, isEdit } = propsReceive;
    return <>
    {isEdit(record) && <Button variant="contained" label="ra.action.edit" onClick={(e) => {
            e.stopPropagation();
            onClick(record);
        }}><ContentCreate /></Button>
    }
    </>
};

export default DialogEdit;